var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMortgageSelling({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.47,
    height: 94.661,
    viewBox: "0 0 85.47 94.661",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10765",
    "data-name": "Group 10765",
    transform: "translate(-1299.19 -1193.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10749",
    "data-name": "Group 10749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_House_contract_-_Flaticon-2",
    "data-name": "Search results for House contract - Flaticon-2",
    transform: "translate(1240.24 1193.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10518",
    "data-name": "Group 10518",
    transform: "translate(66.951 40.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10517",
    "data-name": "Group 10517"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10127",
    "data-name": "Path 10127",
    d: "M158.2,229.53H107.352a1.3,1.3,0,1,0,0,2.59H158.2a1.3,1.3,0,0,0,0-2.59Z",
    transform: "translate(-105.939 -229.525)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10520",
    "data-name": "Group 10520",
    transform: "translate(67.95 54.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10519",
    "data-name": "Group 10519",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10128",
    "data-name": "Path 10128",
    d: "M156.308,304.72H108.733a3.755,3.755,0,0,0-2.412.612.8.8,0,0,0,0,1.365,3.755,3.755,0,0,0,2.412.612h47.575c1.326-.059,2.344-.621,2.344-1.3S157.635,304.779,156.308,304.72Z",
    transform: "translate(-105.939 -304.715)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10522",
    "data-name": "Group 10522",
    transform: "translate(66.95 80.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10521",
    "data-name": "Group 10521",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10129",
    "data-name": "Path 10129",
    d: "M157.246,455.1H108.151c-1.123.059-1.985.621-1.985,1.295s.861,1.236,1.985,1.295h49.093c1.123-.059,1.985-.621,1.985-1.295s-.861-1.236-1.985-1.3Z",
    transform: "translate(-106.167 -455.1)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10522-2",
    "data-name": "Group 10522",
    transform: "translate(66.95 67.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10521-2",
    "data-name": "Group 10521",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10129-2",
    "data-name": "Path 10129",
    d: "M157.246,455.1H108.151c-1.123.059-1.985.621-1.985,1.295s.861,1.236,1.985,1.295h49.093c1.123-.059,1.985-.621,1.985-1.295s-.861-1.236-1.985-1.3Z",
    transform: "translate(-106.167 -455.1)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10524",
    "data-name": "Group 10524",
    transform: "translate(66.931 7.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10523",
    "data-name": "Group 10523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10130",
    "data-name": "Path 10130",
    d: "M128.2,55.2,117.369,45.029a1.3,1.3,0,0,0-1.773,0L104.766,55.2a1.3,1.3,0,1,0,1.773,1.888l9.943-9.34,9.943,9.34A1.3,1.3,0,1,0,128.2,55.2Z",
    transform: "translate(-104.269 -44.68)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10526",
    "data-name": "Group 10526",
    transform: "translate(70.366 13.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10525",
    "data-name": "Group 10525"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10131",
    "data-name": "Path 10131",
    d: "M140.1,81.8l-6.629-6.227a2.145,2.145,0,0,0-2.932,0L123.91,81.8a2.148,2.148,0,0,0-.676,1.561v9.058a2.143,2.143,0,0,0,2.141,2.141h13.258a2.143,2.143,0,0,0,2.141-2.141v-9.06A2.149,2.149,0,0,0,140.1,81.8Zm-7.145,10.17h-1.9V87.48h1.9Zm5.23,0h-2.64V86.66a1.772,1.772,0,0,0-1.77-1.77h-3.541a1.771,1.771,0,0,0-1.769,1.77v5.31h-2.64V83.553h0L132,77.748l6.18,5.805Z",
    transform: "translate(-123.234 -74.994)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10528",
    "data-name": "Group 10528",
    transform: "translate(58.95 0.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10527",
    "data-name": "Group 10527"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10132",
    "data-name": "Path 10132",
    d: "M127.661,36.512a1.293,1.293,0,0,0-1.3,1.286V87.352a.1.1,0,0,1-.1.1H61.638a.1.1,0,0,1-.1-.1V2.661a.1.1,0,0,1,.1-.1H105.7V20.309a2.724,2.724,0,0,0,2.735,2.707h17.928v6.726a1.3,1.3,0,0,0,2.589,0v-8.1a1.272,1.272,0,0,0-.02-.162h0a1.266,1.266,0,0,0-.044-.159.117.117,0,0,0-.014-.04,1.271,1.271,0,0,0-.065-.145V21.13a1.287,1.287,0,0,0-.09-.141l-.025-.034a1.273,1.273,0,0,0-.113-.13L107.908.375a1.279,1.279,0,0,0-.131-.111l-.035-.026A1.315,1.315,0,0,0,107.6.15h-.009a1.3,1.3,0,0,0-.145-.063l-.041-.015a1.3,1.3,0,0,0-.16-.044h-.006a1.325,1.325,0,0,0-.159-.02H61.638A2.678,2.678,0,0,0,58.95,2.67V87.348a2.678,2.678,0,0,0,2.688,2.661h64.623a2.678,2.678,0,0,0,2.688-2.661V37.794a1.293,1.293,0,0,0-1.289-1.282ZM108.288,4.374l16.249,16.081h-16.1a.146.146,0,0,1-.146-.144Z",
    transform: "translate(-58.95 -0.009)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    transform: "translate(1322 1226)",
    fill: "#fff",
    stroke: "#00641f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.33,
    cy: 31.33,
    rx: 31.33,
    ry: 31.33,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.33,
    cy: 31.33,
    rx: 30.83,
    ry: 30.83,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10748",
    "data-name": "Group 10748",
    transform: "translate(930.968 882.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Sell_house_-_Flaticon-2",
    "data-name": "Search results for Sell house - Flaticon-2",
    transform: "translate(402.033 354.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "outline_copy_2",
    "data-name": "outline copy 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9994",
    "data-name": "Path 9994",
    d: "M16.686,267.9H20.8a.686.686,0,0,0,.686-.686v-1.372H24.1l8.168,3.378a.689.689,0,0,0,.2.049v0l9.5-3.85,2.428-1.005a.686.686,0,0,0,.4-.8,3.306,3.306,0,0,0-4.252-2.334l-.021.007-6.561,2.425-2.281-1.3h1.533a3.436,3.436,0,0,0,3.361-2.744H40.7a.686.686,0,0,0,.686-.686v-5.132l.293.2.787-1.124-1.08-.756v-.054h-.078l-5.7-3.993a.686.686,0,0,0-.787,0l-5.7,3.993h-.078v.054l-1.08.756.787,1.124.293-.2v4.446H21.489V257.6a.686.686,0,0,0-.686-.686H16.686A.686.686,0,0,0,16,257.6v9.605a.686.686,0,0,0,.686.686Zm19.292,0,3.349-1.386v.014Zm-.082-9.605H34.525v-3.431H35.9Zm-5.489-5.406,4.8-3.362,4.8,3.362v5.406H37.269v-4.117a.686.686,0,0,0-.686-.686H33.838a.686.686,0,0,0-.686.686v4.117H30.408Zm-8.919,6.778H35.154a2.062,2.062,0,0,1-1.941,1.372H29.1a.686.686,0,0,0-.34,1.282l4.8,2.744a.686.686,0,0,0,.578.048l6.85-2.532a1.938,1.938,0,0,1,2.253.828L32.527,267.84,24.5,264.518a.688.688,0,0,0-.262-.052H21.489Zm-4.117-1.372h2.744v8.233H17.372Z",
    transform: "translate(-16 -228.103)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9995",
    "data-name": "Path 9995",
    d: "M78.421,24.919H74.3a.686.686,0,0,0-.686.686v1.372H70.472L59.7,16.2a.686.686,0,0,0-.97,0,3.6,3.6,0,0,0,0,5.087l.2.2H40.686a.686.686,0,0,0-.686.686v12.35a.686.686,0,0,0,.686.686h19.9a.686.686,0,0,0,.686-.686V32.466h.567a4.8,4.8,0,0,1,1.381.2L69.3,34.5a.688.688,0,0,0,.2.029h4.117v.686a.686.686,0,0,0,.686.686h4.117a.686.686,0,0,0,.686-.686V25.605A.686.686,0,0,0,78.421,24.919ZM59.287,17.733l3.756,3.756H60.867L59.7,20.317A2.229,2.229,0,0,1,59.287,17.733Zm1.982,7.872h.686a1.372,1.372,0,0,1,0,2.744h-.686ZM59.9,33.838H41.372V22.861H59.9v5.489h-.686a3.434,3.434,0,0,0-3.43,3.43.686.686,0,0,0,.686.686H59.9Zm13.722-.686H69.6l-5.993-1.8a6.167,6.167,0,0,0-1.775-.26H57.27a2.062,2.062,0,0,1,1.941-1.372h2.744a2.744,2.744,0,1,0,0-5.489h-.686V22.861h3.146L69.7,28.149a.686.686,0,0,0,.485.2h3.43Zm4.117,1.372H74.991V26.291h2.744Z",
    transform: "translate(-37.942 -16)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9999",
    "data-name": "Path 9999",
    d: "M1.857,0V3.288L.97,2.4,0,3.371,2.058,5.429a.681.681,0,0,0,.969,0h0L5.087,3.371l-.97-.97-.887.887V0Z",
    transform: "translate(8.718 27.49) rotate(180)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10055",
    "data-name": "Path 10055",
    d: "M32.338,194.334a2.865,2.865,0,0,1,1.912,1.954.475.475,0,0,0,.454.346.416.416,0,0,0,.073-.011.441.441,0,0,0,.065.014H46.206a.415.415,0,0,0,.058-.012.44.44,0,0,0,.533-.332v0a2.865,2.865,0,0,1,1.912-1.956.479.479,0,0,0,.325-.533.5.5,0,0,0,.014-.072v-3.877a.448.448,0,0,0-.014-.072.478.478,0,0,0-.325-.533,2.862,2.862,0,0,1-1.911-1.957.467.467,0,0,0-.525-.332.457.457,0,0,0-.067-.014H34.841a.429.429,0,0,0-.071.015.467.467,0,0,0-.521.332,2.865,2.865,0,0,1-1.912,1.956.479.479,0,0,0-.325.533.5.5,0,0,0-.013.072v3.877a.458.458,0,0,0,.013.067A.48.48,0,0,0,32.338,194.334Zm.609-4.285a3.8,3.8,0,0,0,2.086-2.135h10.98a3.8,3.8,0,0,0,2.087,2.135v3.483a3.806,3.806,0,0,0-2.086,2.135H35.034a3.806,3.806,0,0,0-2.086-2.135Z",
    transform: "translate(-27.974 -179.622)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10056",
    "data-name": "Path 10056",
    d: "M130.907,224.76A2.907,2.907,0,1,0,128,221.852,2.907,2.907,0,0,0,130.907,224.76Zm0-4.846a1.938,1.938,0,1,1-1.938,1.938A1.938,1.938,0,0,1,130.907,219.914Z",
    transform: "translate(-118.357 -209.684)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10022_-_Outline",
    "data-name": "Path 10022 - Outline",
    d: "M76.745,256.684a.995.995,0,1,1,.995-.995A1,1,0,0,1,76.745,256.684Z",
    transform: "translate(-69.327 -243.521)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10023_-_Outline",
    "data-name": "Path 10023 - Outline",
    d: "M252.745,256.684a.995.995,0,1,1,.995-.995A1,1,0,0,1,252.745,256.684Z",
    transform: "translate(-235.062 -243.521)",
    fill: "#00641f"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMortgageSelling);
export default __webpack_public_path__ + "static/media/mortgageSelling.71206f30bbacc30aebfc3e9af45a0cdb.svg";
export { ForwardRef as ReactComponent };